module.exports = __webpack_public_path__ + "static/media/sf_hotel_17.3bdc96ea.jpg";